import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const SpringTermActivity = () => import('../views/SpringTermActivity.vue')
const SpringTermActivityPrize = () => import('../views/SpringTermActivityPrize.vue')
const SpringTermActivityPrizeWinnerList = () => import('../views/SpringTermActivityPrizeWinnerList.vue')

const WinterVacationActivity = () => import('../views/WinterVacationActivity.vue')
const WinterVacationTimescopeEdit = () => import('../views/WinterVacationTimescopeEdit.vue')
const WinterVacationHomeworkStatByClazz = () => import('../views/WinterVacationHomeworkStatByClazz.vue')
const WinterVacationHomeworkStatByStudent = () => import('../views/WinterVacationHomeworkStatByStudent.vue')
const WinterVacationHomeworkPosterComp = () => import('../views/WinterVacationHomeworkPoster.vue')

const AiSummerReport = () => import('../views/activity/2608-ai-summer-report/Index.vue')

export const springTermActivityRoute: RouteConfig = {
  path: '/spring-term-activity',
  name: 'spring_term_activity',
  component: SpringTermActivity,
  meta: {
    title: '体育作业',
  },
}

export const springTermActivityPrizeRoute: RouteConfig = {
  path: '/spring-term-activity-prize',
  name: 'spring_term_activity_prize',
  component: SpringTermActivityPrize,
  meta: {
    title: '领取奖励',
  },
}

export const springTermActivityPrizeWinnerListRoute: RouteConfig = {
  path: '/spring-term-activity-prize-winner-list',
  name: 'spring_term_activity_prize_winner_list',
  component: SpringTermActivityPrizeWinnerList,
  meta: {
    title: '学生奖励名单',
  },
}

export const winterVacationActivityRoute: RouteConfig = {
  path: '/winter-vacation-activity',
  name: 'winter_vacation_activity',
  component: WinterVacationActivity,
  meta: {
    title: '寒假作业',
  },
}

export const winterVacationTimescopeEditRoute: RouteConfig = {
  path: '/winter-vacation-timescope-edit',
  name: 'winter_vacation_timescope_edit',
  component: WinterVacationTimescopeEdit,
  meta: {
    title: '寒假时间',
  },
}

export const winterVacationHomeworkStatByClazzRoute: RouteConfig = {
  path: '/winter-vacation-homework-stat-by-clazz',
  name: 'winter_vacation_homework_stat_by_clazz',
  component: WinterVacationHomeworkStatByClazz,
  meta: {
    title: '寒假作业统计',
  },
}

export const winterVacationHomeworkStatByStudentRoute: RouteConfig = {
  path: '/winter-vacation-homework-stat-by-student',
  name: 'winter_vacation_homework_stat_by_student',
  component: WinterVacationHomeworkStatByStudent,
  meta: {
    title: '寒假作业统计',
  },
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: JSON.parse(`${route.query.clazzId}`),
  }),
}

export const winterVacationHomeworkPosterRoute: RouteConfig = {
  path: '/winter-vacation-homework-poster',
  name: 'winter_vacation_homework_poster',
  component: WinterVacationHomeworkPosterComp,
  meta: {
    title: '寒假作业统计报告',
  },
}

export const aiSummerReportRoute: RouteConfig = {
  path: '/activity/2608-ai-summer-report',
  name: 'activity_2608_ai_summer_report',
  component: AiSummerReport,
  props: (route) => ({ json_key: route.query.json_key }),
  meta: {
    title: '暑假体育作业报告',
    ignoreLogin: true,
  },
  alias: ['/activity/2608-ai-summer-report/mobile', '/activity/2608-ai-summer-report/pc'],
}

export const zhejiangMatchesRoute: RouteConfig[] = [
  {
    path: '/match-rank',
    name: 'match_rank',
    component: () => import('kuaidong-activity/src/activity/onlineMatches/SchoolRank.vue'),
    props: (route) => ({ title: route.query.t, activity: route.query.a }),
    meta: {
      title: '比赛数据查询',
    },
  },
  {
    path: '/match-rank-detail',
    name: 'match_rank_detail',
    props: (route) => ({ id: route.query.id, activity: route.query.a }),
    component: () => import('kuaidong-activity/src/activity/onlineMatches/SchoolRankDetail.vue'),
    meta: {
      title: '班级数据详情',
    },
  },
]

export const sprintRaceRoute: RouteConfig = {
  path: '/exam-competition-activity-create',
  name: 'exam_competition_activity_create',
  component: () => import('../views/activity/exam-competition/Create.vue'),
  meta: {
    title: '发布冲刺赛',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

// ======== pe guard 活动

export const peGuardIndex: RouteConfig = {
  path: '/activity-peguard-index',
  name: 'activity_peguard_index',
  component: () => import('../views/activity/peguard/Index.vue'),
  meta: {
    title: '2023新学期方案',
    ignoreLogin: true,
  },
}

export const peGuardUserList: RouteConfig = {
  path: '/activity-peguard-user-list',
  name: 'activity_peguard_user_list',
  component: () => import('../views/activity/peguard/AwardUserList.vue'),
  meta: {
    title: '获奖名单',
  },
}
// 活动 2023年12月 征集寒假作业方案
export const vocationHomeworkDesignIndex: RouteConfig = {
  path: '/activity-vocation-homework-design',
  name: 'activity_vocation_homework_design',
  component: () => import('../views/activity/vocation-homework-design/Index.vue'),
  meta: {
    title: '创新体育作业设计',
    ignoreLogin: true,
  },
}

export const vocationHomeworkDesignUpload: RouteConfig = {
  path: '/activity-vocation-homework-design-upload',
  name: 'activity_vocation_homework_design_upload',
  component: () => import('../views/activity/vocation-homework-design/Upload.vue'),
  meta: {
    title: '创新体育作业设计',
    ignoreLogin: true,
  },
}

export const vocationHomeworkDesignDisplay: RouteConfig = {
  path: '/activity-vocation-homework-design-display',
  name: 'activity_vocation_homework_design_display',
  component: () => import('../views/activity/vocation-homework-design/DisplayFile.vue'),
  meta: {
    title: '创新体育作业设计',
    ignoreLogin: true,
  },
}

export const reportRecruit: RouteConfig = {
  path: '/activity-reportor-recruit',
  name: 'activity_reportor_recruit',
  component: () => import('../views/activity/reportor-recruit/Index.vue'),
  meta: {
    title: ' ',
    ignoreLogin: true,
  },
}

export const landingCustom: RouteConfig = {
  path: '/activity/landing/:code',
  name: 'activity_landing_code',
  component: () => import('../views/activity/landing-custom/Index.vue'),
  props: (route) => ({ code: route.params.code }),
  meta: {
    title: '体智云',
    ignoreLogin: true,
  },
}

export const certficateIndex: RouteConfig = {
  path: '/activity/certificate/index',
  name: 'activity_certificate_index',
  component: () => import('../views/activity/certificate/Index.vue'),
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '获取证书',
    ignoreLogin: true,
  },
}

export const certficateShow: RouteConfig = {
  path: '/activity/certificate/show',
  name: 'activity_certificate_show',
  component: () => import('../views/activity/certificate/Show.vue'),
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '证书详情',
    ignoreLogin: true,
  },
}

const RActivity: RouteConfig[] = [
  springTermActivityRoute,
  // springTermActivityPrizeRoute,
  // springTermActivityPrizeWinnerListRoute,
  sprintRaceRoute,
  peGuardIndex,
  peGuardUserList,
  ...zhejiangMatchesRoute,
  vocationHomeworkDesignIndex,
  vocationHomeworkDesignUpload,
  vocationHomeworkDesignDisplay,
  reportRecruit,
  landingCustom,

  certficateIndex,
  certficateShow,
  aiSummerReportRoute,
]

export default RActivity

export function navigateToWinterVacationHomeworkStatbyClazz(router: VueRouter) {
  router.push({ name: winterVacationHomeworkStatByClazzRoute.name })
}

export function navigateToWinterVacationHomeworkStatByStudent(router: VueRouter, clazzId: number) {
  router.push({ name: winterVacationHomeworkStatByStudentRoute.name, query: { clazzId: `${clazzId}` } })
}

export function navigateToWinterVacationHomeworkPoster(router: VueRouter) {
  router.push({ name: winterVacationHomeworkPosterRoute.name })
}

export function navigateToSpringTermActivity(router: VueRouter) {
  router.push({ name: springTermActivityRoute.name })
}

export function navigateToSpringTermActivityPrize(router: VueRouter) {
  router.push({ name: springTermActivityPrizeRoute.name })
}

export function navigateToSpringTermActivityPrizeWinnerList(router: VueRouter) {
  router.push({ name: springTermActivityPrizeWinnerListRoute.name })
}
